import { FaBook, FaBrain, FaGauge, FaTableColumns, FaGears, FaHeartPulse, FaSackDollar, FaUsers, FaUsersGear } from "react-icons/fa6";

export default {
    header: {
        self: {},
        items: [],
    },
    aside: {
        self: {},
        items: [
            {
                title: "Dashboard",
                root: true,
                iconComponent: <FaGauge size={18} />,
                page: "dashboard",
                bullet: "dot",
            },
            {
                title: "Quadro de trabalho",
                root: true,
                iconComponent: <FaTableColumns size={18} />,
                page: "work-order",
                bullet: "dot",
            },
            {
                title: "Clientes",
                root: true,
                iconComponent: <FaUsers size={18} />,
                page: "customer",
                bullet: "dot",
            },
            {
                title: "Fábrica",
                root: true,
                iconComponent: <FaGears size={18} />,
                submenu: [
                    {
                        title: "Materiais",
                        page: "material",
                        bullet: "text",
                    },
                    {
                        title: "Máquinas",
                        page: "machine",
                        bullet: "text",
                    },
                    {
                        title: "Ferramentas",
                        page: "tool",
                        bullet: "text",
                    },
                ],
            },
            {
                title: "Orçamento",
                root: true,
                iconComponent: <FaSackDollar size={18} />,
                submenu: [
                    {
                        title: "Orçamentos",
                        page: "quotation",
                        bullet: "text",
                    },
                    {
                        title: "Parâmetros de custo",
                        page: "cost-parameter",
                        bullet: "text",
                    },
                    {
                        title: "Regras de preço",
                        page: "pricing-rule",
                        bullet: "text",
                    },
                ],
            },
            {
                title: "Conhecimento",
                root: true,
                iconComponent: <FaBook size={18} />,
                page: "knowledge",
                bullet: "dot",
            },
            {
                title: "Diagnóstico",
                root: true,
                iconComponent: <FaHeartPulse size={18} />,
                page: "diagnostics",
                bullet: "dot",
            },
            {
                title: "Acurácia da IA",
                root: true,
                iconComponent: <FaBrain size={18} />,
                page: "ai-accuracy",
                bullet: "dot",
            },
            {
                title: "Acessos",
                root: true,
                iconComponent: <FaUsersGear size={18} />,
                submenu: [
                    {
                        title: "Administradores",
                        page: "admin-user",
                        bullet: "text",
                    },
                    {
                        title: "Grupos de permissões",
                        page: "admin-group",
                        bullet: "text",
                    },
                ],
            },
        ],
    },
};
